/**
 * @constant emetIndications
 * @description
 * Contiene las instrucciones iniciales para la certificación EMET, incluyendo 
 * el tiempo estimado y recomendaciones importantes para el candidato.
 *
 * @property {number} estimatedTime - Tiempo total estimado para completar la certificación (en minutos).
 * @property {Array<Object>} indications - Lista de indicaciones que debe conocer el usuario antes de comenzar.
 * @property {string} indications[].icon - Nombre del ícono representativo de la indicación.
 * @property {string} indications[].color - Color del ícono o alerta asociado.
 * @property {string} indications[].title - Título de la indicación.
 * @property {string} indications[].description - Descripción detallada de la indicación.
 */
export const emetIndications = {
	estimatedTime: 205,
	indications: [
		{
			icon: 'timer',
			color: 'success',
			title: 'Tiempo estimado',
			description: `El tiempo estimado para terminar esta certificación es: 3 horas y 25 minutos minutos.`
		},
		{
			icon: 'distractions',
			color: 'primary',
			title: 'Distracciones',
			description: 'Evita tener distracciones. Si durante los siguientes minutos tienes algún compromiso, evita iniciar esta certificación hasta contar con el tiempo necesario.'
		},
		{
			icon: 'play',
			color: 'primary',
			title: 'Submit',
			description: 'Ten en cuenta que al dar click a submit pasarás a la siguiente pregunta y ya no podrás regresar a las preguntas anteriores.'
		},
		{
			icon: 'lostConnection',
			color: 'primary',
			title: 'Conexión',
			description: 'En caso de que cierres la pestaña o pierdas la conexión de internet perderás tu examen, es necesario comunicarte con tu profesor y al área de operaciones de CertifiED.'
		}, 
		{
			icon: 'timer',
			color: 'primary',
			title: 'Tiempo por pregunta',
			description: 'En la parte superior podrás ver cuánto tiempo tienes para responder cada pregunta.'
		}
	]
}